import { Container, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { formatToCommaWithLang, t, useChipSetStore, useVoucherStore } from '@slot-nx/core'
import { GameStatus, useGameStore } from '../domain/game/store/GameStore'
import { useGodziDropStore } from '../domain/godzi/store/godziDropStore'
import { useMemo } from 'react'
interface StakeContainerProps {
  x: number
  y: number
}

export const StakeContainer = (props: StakeContainerProps) => {
  const [currentStake] = useChipSetStore(x => [x.computed.currentStake])
  const gameStatus = useGameStore(x => x.gameStatus)
  const godziEffectiveStake = useGodziDropStore.getState().effectiveStake
  const voucherFixedStake = useVoucherStore(x => x.fixedStake)

  const displayStake = useMemo(() => {
    if (gameStatus === GameStatus.Voucher) {
      return voucherFixedStake
    }
    else if (gameStatus === GameStatus.Godzi) {
      return godziEffectiveStake
    }
    else {
      return currentStake
    }
  }, [godziEffectiveStake, voucherFixedStake, gameStatus, currentStake])

  return (
    <Container x={props.x} y={props.y} name="stake container">
      <Text
        text={t('stake')}
        anchor={0.5}
        y={0}
        style={
          new TextStyle({
            fontSize: 38,
            fill: '#FFD154',
            align: 'center',
            stroke: '#FFD154',
            strokeThickness: 2,
            letterSpacing: 2,
          })
        }
      />
      <Text
        text={formatToCommaWithLang(displayStake)}
        anchor={0.5}
        y={56}
        style={
          new TextStyle({
            fontSize: 38,
            fill: 'white',
          })
        }
      />
    </Container>
  )
}
